import React from 'react';
import { Badge } from '../Badge';
import * as S from './styled';
export const BadgePreview = ({ emoji, text, borderColor, backgroundColor, textColor, title, }) => (React.createElement("div", null,
    title && React.createElement(S.Title, null, title),
    React.createElement(S.Container, null,
        React.createElement(Badge, { emoji: emoji, text: text, borderColor: borderColor, backgroundColor: backgroundColor, textColor: textColor }))));
